export class AudioManager {
    public sounds: Map<string, HTMLAudioElement>;

    public constructor() {
        this.sounds = new Map<string, HTMLAudioElement>();

    }

    public createAudio(name: string, src: string): HTMLAudioElement {
        const audio: HTMLAudioElement = new Audio(src);
        this.sounds.set(name, audio);
        return audio;
    }

    public playAudio(name: string, volume: number = 1.0, loop: boolean = false): void {
        const audio: HTMLAudioElement | undefined = this.sounds.get(name);
        if (audio) {
            audio.volume = volume;
            audio.loop = loop;
            audio.play().catch((error: any) => {
                console.error(`Error while playing ${name} audio:`, error);
            });
        } else {
            console.error(`Audio ${name} not found.`);
        }
    }

    public setVolume(audioId: string, volume: number): void {
        const audio: HTMLAudioElement | undefined = this.sounds.get(audioId);
        if (audio) {
            audio.volume = volume;
        }
    }
    

    public stopAudio(name: string): void {
        const audio: HTMLAudioElement | undefined = this.sounds.get(name);
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
        }
    }

    public stopAllAudio(): void {
        this.sounds.forEach((audio: HTMLAudioElement) => {
            audio.pause();
            audio.currentTime = 0;
        });
    }

    public removeAudio(name: string): void {
        const audio: HTMLAudioElement | undefined = this.sounds.get(name);
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
            this.sounds.delete(name);
        }
    }
}
